import { FC } from 'react';

// material-ui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { IconLogout } from '@tabler/icons-react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

interface ILogoutModalProps {
  showModal: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}

const CircularIcon: FC = function CircularIcon() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 40,
        height: 40,
        color: 'white',
        bgcolor: 'error.main',
        borderRadius: '50%',
      }}
    >
      <IconLogout stroke={1.5} size="20px" />
    </Box>
  );
};

const LogoutModal: FC<ILogoutModalProps> = function LogoutModal({
  showModal,
  handleConfirm,
  handleClose,
}) {
  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ p: 3 }}
    >
      {showModal && (
        <>
          <DialogTitle id="alert-dialog-title" sx={{ alignSelf: 'center' }}>
            <CircularIcon />
          </DialogTitle>
          <DialogContent sx={{ width: '400px' }}>
            <Stack direction="column" alignItems="center">
              <Typography variant="h3" component="span">
                Logout?
              </Typography>
              <Typography variant="body2" component="span">
                Do you want to log out?
              </Typography>
            </Stack>
          </DialogContent>
          <DialogActions sx={{ pr: 2.5, justifyContent: 'center' }}>
            <Button onClick={handleClose} color="error">
              Cancel
            </Button>
            <Button variant="contained" color="error" onClick={handleConfirm}>
              Yes, log out
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default LogoutModal;
